import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'ui-product-detail-skeleton',
  templateUrl: './product-detail-skeleton.component.html',
  styleUrls: ['./product-detail-skeleton.component.scss', '../product-detail-form/product-detail-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgxSkeletonLoaderModule,
  ],
})
export class ProductDetailSkeletonComponent {
}
